// src/api/booking/booking.js
import { API_BASE } from "../../utils/api";

// fetch available slots for a given date
export async function getAvailableSlots(date) {
  const res = await fetch(`${API_BASE}/api/available-slots/${date}`, {
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error("Failed to fetch available slots");
  }

  return res.json();
}

// get booking info after checkout
export async function getBookingInfo(sessionId) {
  const res = await fetch(
    `${API_BASE}/api/booking-info?session_id=${encodeURIComponent(sessionId)}`,
    { cache: "no-store" }
  );

  const data = await res.json();

  if (!res.ok) {
    const error = new Error(
      data?.message || data?.error || "Failed to fetch booking info"
    );

    error.status = res.status;
    error.data = data;

    throw error;
  }

  return data;
}